import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { Row } from "@/components/General/Grid/row.component";
import { useFlyoutMenuContext } from "@/components/Navigation/FlyoutMenu/context/flyoutMenu.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Categories = ({ className, children }: Props) => {
    const { categories } = useFlyoutMenuContext();

    return (
        <Row className={cn("tw:h-full", className)}>
            <Mapped array={categories}>{children}</Mapped>
        </Row>
    );
};
